import store from '@/store/'
// eslint-disable-next-line no-unused-vars
export default function auth({ from, next, router, to }) {
  // console.log('middleware/auth | from', from)
  // console.log('middleware/auth | to', to)

  // redirect to login if unauthenticated
  if (!store.getters['auth/is_auth']) {
    store.dispatch('CANCEL_PENDING_REQUESTS')
    if (router.currentRoute.name !== 'login') {
      return router.push({ name: 'login' })
    } else {
      return
    }

    // handle user onboarding
  } else if (store.getters['auth/is_onboarding']) {
    store.dispatch('CANCEL_PENDING_REQUESTS')

    if (router.currentRoute.name !== 'subscription') {
      return router.push({ name: 'subscription' })
    } else {
      return
    }

    // suspended account
  } else if (store.getters['auth/is_suspended']) {
    store.dispatch('CANCEL_PENDING_REQUESTS')
    if (router.currentRoute.name !== 'suspended') {
      return router.push({ name: 'suspended' })
    } else {
      return
    }

    // restrict influencer
    /* } else if (store.getters['user/type'] === 'influencer') {
    store.dispatch('CANCEL_PENDING_REQUESTS')
    if (router.currentRoute.name !== 'creator-profile') {
      return router.push({ name: 'creator-profile' })
    } else {
      return
    }
    */

    // restrict agency client
  } else if (
    store.getters['user/type'] === 'agency-client'
    // store.getters['user/type'] === 'publisher' ||
    // store.getters['user/type'] === 'traffic-manager'
  ) {
    if (to.path.match('campaign|account|content-approval-download|social-boost|ai-assistant')) {
      return next()
    } else {
      return router.push({ name: 'campaigns' })
    }
    // SRR-2595: Flaminjoy Graphic Designer no longer has Dashboard access — send to their usual landing page.
  } else if (['traffic-manager', 'publisher', 'graphic-designer'].includes(store.getters['user/type'])) {
    if (to.name === 'dashboard-child') {
      return router.push({ name: 'social-boost' })
    }
  }

  // OR do nothing and go next
  return next()
}
